// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSubscribeButton_root__gKlUS","rootsubscribed":"PlasmicSubscribeButton_rootsubscribed__EyOmM","text":"PlasmicSubscribeButton_text__4oiUc"};